// components/DepartureCard.jsx
import React, { useState } from 'react';
import { formatTime, calculateTimeRemaining } from '../utils/time';
import { getFullHeadsign } from '../utils/headsigns';
import DepartureDetailModal from './DepartureDetailModal';

function DepartureCard({ departure }) {
    const [showDetail, setShowDetail] = useState(false);
    const timeRemaining = calculateTimeRemaining(departure.estimatedTime);
    const fullHeadsign = getFullHeadsign(departure.headsign);

    const routeNum = Number(departure.routeShortName);
    const isTram = !isNaN(routeNum) && routeNum < 100;

    const getDelayInfo = (delayInSeconds) => {
        if (delayInSeconds === null || delayInSeconds === undefined) {
            return { text: null, ok: true };
        }
        const minutes = Math.floor(Math.abs(delayInSeconds) / 60);
        if (Math.abs(delayInSeconds) < 60) return { text: null, ok: true };
        if (delayInSeconds > 0) return { text: `+${minutes} min`, ok: false };
        return { text: `-${minutes} min`, ok: true };
    };

    const parseCountdown = (timeStr) => {
        if (!timeStr || timeStr.includes('Odjazd')) return -1;
        const match = timeStr.match(/(\d+)m\s*(\d*)s?/);
        if (match) {
            return (parseInt(match[1]) || 0) * 60 + (parseInt(match[2]) || 0);
        }
        return -1;
    };

    const getCountdownDisplay = (timeStr) => {
        const total = parseCountdown(timeStr);
        if (total < 0) return '—';
        if (total < 60) return '<1';
        return String(Math.floor(total / 60));
    };

    const delayInfo = getDelayInfo(departure.delayInSeconds);
    const totalSeconds = parseCountdown(timeRemaining);
    const countdownDisplay = getCountdownDisplay(timeRemaining);
    const isSoon = totalSeconds >= 0 && totalSeconds < 180;

    return (
        <>
            <div
                className={`dep-row${isSoon ? ' dep-row--soon' : ''}`}
                onClick={() => setShowDetail(true)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter') setShowDetail(true); }}
                aria-label={`Szczegóły odjazdu linii ${departure.routeShortName} kierunek ${departure.headsign}`}
            >
                <div className={`dep-chip${isTram ? ' dep-chip--tram' : ' dep-chip--bus'}`}>
                    {departure.routeShortName}
                </div>

                <div className="dep-middle">
                    <div className="dep-direction" title={fullHeadsign}>{fullHeadsign}</div>
                    <div className="dep-meta">
                        <span className="dep-time">{formatTime(departure.estimatedTime)}</span>
                        {delayInfo.ok
                            ? <span className="dep-badge dep-badge--ok">
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 3 }}><path d="M5 12l5 5 9-11"/></svg>
                                punkt.
                              </span>
                            : <span className="dep-badge dep-badge--late">{delayInfo.text}</span>
                        }
                    </div>
                </div>

                <div className="dep-countdown-col">
                    <span className={`dep-countdown-num${isSoon ? ' dep-countdown-num--soon' : ''}`}>
                        {countdownDisplay}
                    </span>
                    <span className="dep-countdown-unit">min</span>
                </div>
            </div>

            {showDetail && (
                <DepartureDetailModal
                    departure={departure}
                    onClose={() => setShowDetail(false)}
                />
            )}
        </>
    );
}

export default DepartureCard;
